import type { Messages } from "./en"

export const uz: Messages = {
  common: {
    loading: "Yuklanmoqda…",
    createAgent: "Agent yaratish",
    loadAgentsFailed: "Agentlarni yuklab boʻlmadi.",
    toolCount_one: "{count} ta vosita",
    toolCount_few: "{count} ta vosita",
    toolCount_many: "{count} ta vosita",
    toolCount_other: "{count} ta vosita",
    enabled: "Yoqilgan",
    disconnect: "Uzish",
    connectedAs: "Ulangan:",
    disconnectFailed: "Uzib boʻlmadi.",
    cancel: "Bekor qilish",
    contactAdmin: "Admin bilan bogʻlanish",
    errorTitle: "Nimadir xato ketdi",
    errorBody: "Ilovada kutilmagan xatolik yuz berdi. Sahifani yangilang, agar takrorlansa — admin bilan bogʻlaning.",
    errorReload: "Yangilash",
    name: "Nomi",
    actionFailed: "Ishlamadi.",
    expandAll: "Barchasini yoyish",
    collapseAll: "Barchasini yigʻish",
    showLess: "kamroq koʻrsatish",
    showAllChars: "{count} ta belgini koʻrsatish",
    itemCount_one: "{count} ta element",
    itemCount_few: "{count} ta element",
    itemCount_many: "{count} ta element",
    itemCount_other: "{count} ta element",
    keyCount_one: "{count} ta kalit",
    keyCount_few: "{count} ta kalit",
    keyCount_many: "{count} ta kalit",
    keyCount_other: "{count} ta kalit",
    status: {
      disabled: "Oʻchirilgan",
      run: {
        queued: "Navbatda",
        running: "Bajarilmoqda",
        succeeded: "Muvaffaqiyatli",
        failed: "Xatolik",
        cancelled: "Bekor qilindi",
        maxIterations: "Qadam chegarasiga yetdi",
        timeout: "Vaqt tugadi",
        abandoned: "Tark etilgan",
      },
      connection: {
        connected: "Ulangan",
        unreachable: "Ishlamayapti",
        notChecked: "Tekshirilmagan",
      },
    },
  },
  nav: {
    guide: "Qoʻllanma",
    chat: "Chat",
    agents: "Agentlar",
    toolServers: "Vosita serverlari",
    plugins: "Plaginlar",
    schedules: "Jadvallar",
    runs: "Ishga tushirishlar",
    activity: "Faollik",
    workspace: "Ish maydoni",
    billing: "Billing",
    admin: "Admin",
    theme: "Mavzu",
    language: "Til",
    signOut: "Chiqish",
    openMenu: "Menyuni ochish",
    closeMenu: "Menyuni yopish",
  },
  workspace: {
    switcherLabel: "Ish maydoni",
    loadFailed: "Ish maydonlarini yuklab boʻlmadi.",
    new: "Yangi ish maydoni",
    newLabel: "Ish maydoni yaratish",
    dialogDescription: "Yangi ish maydoniga nom bering. Yaratilgach, unga oʻtasiz.",
    namePlaceholder: "Acme Inc.",
    create: "Ish maydoni yaratish",
    toastCreated: "Ish maydoni yaratildi.",
    createFailed: "Ish maydonini yaratib boʻlmadi.",
  },
  guide: {
    title: "Qoʻllanma",
    intro:
      "Bu yerda oʻz AI yordamchilaringizni yaratasiz — biz ularni **agentlar** deb ataymiz. Agent siz bilan suhbatlashadi, u nima uchun kerakligini va qaysi vositalardan foydalana olishini esa siz hal qilasiz. U bilan shu yerda, vebda yoki Telegram orqali gaplashish mumkin, hatto siz yoʻq paytingizda jadval boʻyicha ham ishlay oladi.",
    useCases: {
      title: "Nimalar qilish mumkin",
      intro: "Odamlar agentlarini sozlaydigan bir nechta ishlar:",
      usesLabel: "Ishlatadi: {name}",
      items: {
        spending: {
          title: "Xarajatlarni kuzatish",
          blurb: "Nimaga pul sarflaganingizni ayting va bu oy pul qayerga ketganini soʻrang.",
          using: "Expense Tracker plagini",
        },
        email: {
          title: "Email bilan ishlash",
          blurb: "Xatlarni oʻqib, qisqacha bayon qilib, javob qoralamalarini tayyorlab beradi.",
          using: "Mail plagini",
        },
        calendar: {
          title: "Kalendar va eslatmalar",
          blurb: "Bugun nima rejalashtirilganini soʻrang yoki tadbirni shunchaki taʼriflab qoʻshing.",
          using: "Google Calendar plagini",
        },
        briefings: {
          title: "Muntazam xulosalar",
          blurb: "Har kuni ertalab kunlik xulosani avtomatik oling.",
          using: "Jadvallar",
        },
        tools: {
          title: "Oʻz vositalaringiz",
          blurb: "Istalgan vosita serverini ulang — agent ish jarayonida uni chaqira oladi.",
          using: "Vosita serverlari (MCP)",
        },
        telegram: {
          title: "Telegramdan suhbat",
          blurb: "Agentingizga telefondan, oddiy Telegram chati kabi yozing.",
          using: "Telegram",
        },
      },
    },
    createAgent: {
      title: "Birinchi agentingizni yarating",
      intro:
        "Agent — bor-yoʻgʻi uch narsa: model (miya), koʻrsatmalaringiz (nima qilishi kerak) va foydalanishga ruxsat bergan vositalaringiz. Sozlash bir daqiqa oladi.",
      step1: "**Agentlar** boʻlimiga oʻting va **Yangi agent** tugmasini bosing.",
      step2: "Unga nom bering — masalan, “Pul yordamchisi” yoki “Email yordamchisi”.",
      step3:
        "Nima qilishi kerakligini oddiy soʻzlar bilan yozing, masalan: “Sen xarajatlarimni kuzatishga yordam berasan va byudjet haqidagi savollarga javob berasan”.",
      step4: "Kerakli vositalarni yoqing (quyida koʻring), soʻng saqlang.",
      step5: "**Chat**ni oching, agentingizni tanlang va salom deng.",
      cta: "Agent yaratish",
    },
    tools: {
      title: "Unga vositalar bering",
      body:
        "Vositalar agentga faqat gapirish emas, haqiqatan ham *ish qilish* imkonini beradi. Eng osoni — **plaginlar**: xarajat kuzatuvchisi, pochta va kalendar kabi tayyor vositalar; ularni agent uchun yoqib qoʻyasiz. Maxsus narsalar uchun oʻzingizning **vosita serveringizni** ham ulashingiz mumkin.",
      browsePlugins: "Plaginlarni koʻrish",
      connectServer: "Vosita serverini ulash",
    },
    notion: {
      title: "Notionni ulang",
      intro:
        "Agent Notion sahifalaringiz va maʼlumotlar bazalaringizni oʻqishi va yangilashi mumkin. Bitta token kifoya — agent faqat siz unga ulashgan sahifalarni koʻradi.",
      step1:
        "Notionda **notion.so/profile/integrations** sahifasini oching va **New integration** tugmasini bosing. Ish maydonini tanlang va integratsiyaga nom bering — masalan, “Mening agentim”.",
      step2:
        "Yaratilgan integratsiyani oching va uning **Internal Integration Secret**ini nusxalang — `ntn_` bilan boshlanadigan token. Kerakli yagona kalit shu.",
      step3:
        "Yana Notionda agent koʻrishi kerak boʻlgan har bir sahifa yoki bazani oching, **⋯** menyusi → **Connections** orqali integratsiyangizni qoʻshing. Ichki sahifalar avtomatik qoʻshiladi.",
      step4:
        "Bu yerda agentingizning **Plaginlar** boʻlimini oching, **Notion**ni yoqing va tokenni Notion paneliga joylashtiring. U darhol tekshiriladi va shifrlangan holda saqlanadi.",
      step5:
        "**Chat**ni oching va sinab koʻring: agentdan siz ulashgan sahifalardan birida nima borligini soʻrang.",
      openAgents: "Mening agentlarim",
    },
    telegram: {
      title: "Uni Telegramga ulang",
      intro:
        "Agentingizga telefondan murojaat qilmoqchimisiz? Unga alohida Telegram bot oching. Faqat siz roʻyxatga kiritgan odamlar u bilan gaplasha oladi.",
      step1:
        "Telegramda **@BotFather**ni oching va `/newbot` yuboring. Botga nom berish uchun koʻrsatmalarga amal qiling.",
      step2:
        "BotFather sizga **token** beradi — `12345:ABC…` koʻrinishidagi uzun qator. Uni nusxalang.",
      step3: "Bu yerda agentingizni oching, **Telegram** boʻlimini toping va tokenni joylashtiring.",
      step4:
        "Botga yoza olishingiz uchun oʻzingizning **Telegram user id**ingizni ruxsat roʻyxatiga qoʻshing. Idni bilish uchun Telegramda **@userinfobot**ni oching — u raqamingizni yuboradi.",
      step5:
        "Saqlang, soʻng yangi botingizni Telegramda oching va unga xabar yozing. Agentingiz javob beradi.",
      openAgents: "Mening agentlarim",
    },
    schedule: {
      title: "Jadval boʻyicha ishga tushiring",
      body:
        "Agent sizni kutishi shart emas. Jadval belgilang — u oʻzi ishlaydi: ertalabki xulosa, haftalik hisobot, tungi tekshiruv. Har bir ishga tushirish saqlanadi, nima qilgani aniq koʻrinadi.",
      cta: "Jadval sozlash",
    },
  },
  landing: {
    meta: {
      title: "AI Agents — oʻz vositalaringiz bilan shaxsiy AI yordamchilar",
      description:
        "AI Agents — shaxsiy AI yordamchilar yaratish platformasi: agentlarni taʼriflang, oʻzingiz roʻyxatdan oʻtkazgan MCP serverlar orqali vositalarni ulang, ular bilan jonli suhbatlashing va jadval boʻyicha ishga tushiring.",
    },
    signIn: "Kirish",
    openApp: "Ilovani ochish",
    getStarted: "Boshlash",
    hero: {
      title: "Agentlaringiz oʻzingizniki. Oʻz vositalaringizni ulang.",
      subtitle:
        "AI Agents — shaxsiy AI yordamchilar yaratish platformasi. Siz agentlarni taʼriflaysiz, oʻzingiz roʻyxatdan oʻtkazgan MCP serverlar orqali vositalarni ulaysiz, ular bilan jonli suhbatlashasiz va jadval boʻyicha ishga tushirasiz — har bir ishga tushirish toʻliq kuzatiladi.",
    },
    features: {
      ownAgents: {
        title: "Oʻz agentlaringiz",
        text: "Oʻz system promptlari, modellari va vositalariga ega agentlar yarating. Har bir agent sizga tegishli.",
      },
      ownTools: {
        title: "Oʻz vositalaringizni ulang",
        text: "Oʻzingiz boshqaradigan masofaviy MCP serverlarni roʻyxatdan oʻtkazing. Platforma ularning vosita kataloglarini topadi; har bir agent qaysi vositalarni chaqira olishini siz tanlaysiz.",
      },
      liveChat: {
        title: "Jonli chat",
        text: "Agentlar bilan oqimli javoblar orqali suhbatlashing va vosita chaqiruvlarini real vaqtda kuzating.",
      },
      schedules: {
        title: "Jadvallar",
        text: "Agentlarni cron jadvali boʻyicha avtomatik ishga tushiring — hisobotlar, tekshiruvlar va kundalik ishlar siz uxlayotganda ham bajariladi.",
      },
      traces: {
        title: "Toʻliq trassalar",
        text: "Har bir ishga tushirish yozib boriladi: iteratsiyalar, token sarfi va har bir vosita chaqiruvining toʻliq trassasi.",
      },
      selfHost: {
        title: "Oʻz serveringizda",
        text: "Faqat FastAPI va Postgres, boshqa hech narsa. Maʼlumotlaringiz va hisob maʼlumotlaringiz oʻz serveringizda, shifrlangan holda saqlanadi.",
      },
    },
    google: {
      title: "Google orqali kirish",
      body: "Email va parol bilan hisob yaratishingiz yoki Google orqali kirishingiz mumkin. Google orqali kirganingizda AI Agents faqat Google hisobingiz identifikatori, email manzilingiz va ismingizni oladi va ulardan bitta maqsadda foydalanadi: hisobingizni yaratish va tizimga kiritish. AI Agents Gmail, Google Drive, Google Calendar, kontaktlar yoki boshqa Google maʼlumotlaringizga kirishni soʻramaydi hamda maʼlumotlaringizni hech qachon sotmaydi va ulashmaydi.",
      privacyBefore: "Servis nimalarni saqlashi va ulardan qanday foydalanishi haqida",
      privacyLink: "maxfiylik siyosatida",
      privacyAfter: "oʻqing.",
    },
    footer: {
      copyright: "© {year} AI Agents",
      privacy: "Maxfiylik siyosati",
    },
  },
  login: {
    tagline: "Agentlaringiz oʻzingizniki. Oʻz vositalaringizni ulang.",
    tabs: { signIn: "Kirish", signUp: "Hisob yaratish" },
    email: "Email",
    password: "Parol",
    passwordHint: "Kamida 8 ta belgi",
    codeLabel: "Tasdiqlash kodi",
    codePlaceholder: "6 xonali kod",
    resend: "Kodni qayta yuborish",
    submit: {
      wait: "Kuting…",
      signIn: "Kirish",
      verify: "Tasdiqlash va hisob yaratish",
      sendCode: "Kod yuborish",
      signUp: "Hisob yaratish",
    },
    forgot: "Parolni unutdingizmi?",
    or: "yoki",
    toasts: {
      codeSent: "Sizga 6 xonali tasdiqlash kodini yubordik.",
      codeResent: "Yangi kod yoʻlda.",
      resendFailed: "Kodni qayta yuborib boʻlmadi.",
      googleFailed: "Google orqali kirib boʻlmadi. Qayta urinib koʻring.",
      genericError: "Xatolik yuz berdi. Qayta urinib koʻring.",
    },
  },
  acceptInvite: {
    title: "Ish maydoniga taklif",
    invitedBy: "{who} taklif qildi",
    sentTo: "Bu taklif {email} manziliga yuborilgan.",
    checking: "Taklifni tekshiryapmiz…",
    accepting: "Ish maydoniga qoʻshilyapmiz…",
    continue: "Davom etish",
    genericError: "Bu taklifni qabul qilib boʻlmadi.",
  },
  chat: {
    toasts: {
      loadConversationFailed: "Bu suhbatni yuklab boʻlmadi.",
      connectionDropped: "Ulanish uzildi. Nima saqlanganini koʻrish uchun sahifani qayta yuklang.",
      startRunFailed: "Ishga tushirib boʻlmadi.",
    },
    noAgents: {
      title: "Suhbatni boshlash uchun agent yarating",
      description:
        "Agent — bu model, koʻrsatmalaringiz va ruxsat bergan vositalar. Suhbatlashishdan oldin sizga agent kerak.",
      newHere: "Birinchi marta keldingizmi?",
      readGuide: "Qoʻllanmani oʻqish",
    },
    pickAgent: "Agentni tanlang",
    newConversation: "Yangi suhbat",
    noConversations: "Hozircha suhbatlar yoʻq.",
    untitledConversation: "Nomsiz",
    you: "Siz",
    agentFallback: "Agent",
    thisAgentFallback: "Bu agent",
    fallbackAgentNameLower: "agentingiz",
    emptyMessages: {
      title: "Boshlash uchun biror narsa yozing",
      withTools_one: "{name} sizga javob berish uchun {count} ta vositadan foydalana oladi.",
      withTools_few: "{name} sizga javob berish uchun {count} ta vositadan foydalana oladi.",
      withTools_many: "{name} sizga javob berish uchun {count} ta vositadan foydalana oladi.",
      withTools_other: "{name} sizga javob berish uchun {count} ta vositadan foydalana oladi.",
      noTools: "{name}da hali vositalar yoʻq. Uni foydaliroq qilish uchun vosita serverini ulang.",
    },
    assistantThinking: "Oʻylamoqda…",
    messagePlaceholder: "{name} uchun xabar…",
    messageAriaLabel: "{name} uchun xabar",
    stop: "Toʻxtatish",
    send: "Yuborish",
    hint: {
      busy: "Agent ishlayapti… yozishda davom etishingiz mumkin",
      idle: "Enter — yuborish · Shift+Enter — yangi qator",
    },
    truncated: "qisqartirilgan",
    emptyAssistantMessage: "(hech narsa demay, vositalardan foydalandi)",
    reasoning: {
      live: "Oʻylamoqda…",
      label: "Fikrlash jarayoni",
    },
    attach: "Rasm biriktirish",
    removeImage: "Rasmni olib tashlash",
    imageTooLarge: "Rasm hajmi 10 MB dan oshmasligi kerak.",
    tooManyImages: "Bitta xabarga koʻpi bilan 4 ta rasm biriktirish mumkin.",
    attachmentUploadFailed: "Rasmni yuklab boʻlmadi.",
  },
  agents: {
    title: "Agentlar",
    description: "Har bir agentning oʻz koʻrsatmalari, modeli va vositalar toʻplami bor.",
    newAgent: "Yangi agent",
    empty: {
      title: "Hozircha agentlar yoʻq",
      description:
        "Agent — bu model, tizim prompt va foydalanishga ruxsat bergan vositalar. Suhbatni boshlash uchun agent yarating.",
    },
    noDescription: "Tavsif yoʻq.",
    chatAction: "Chat",
    editAria: "{name}ni tahrirlash",
  },
  editor: {
    toasts: {
      loadFailed: "Bu agentni yuklab boʻlmadi.",
      saved: "{name} saqlandi.",
      saveFailed: "Bu agentni saqlab boʻlmadi.",
      deleted: "Agent oʻchirildi.",
      deleteFailed: "Bu agentni oʻchirib boʻlmadi.",
    },
    noProvider: {
      title: "Model provayderi sozlanmagan",
      description: "Serverda DEEPSEEK_API_KEY (yoki LLM_PROVIDERS) ni belgilang va uni qayta ishga tushiring.",
    },
    basics: {
      title: "Asosiy",
      nameLabel: "Nomi",
      namePlaceholder: "Qoʻllab-quvvatlash yordamchisi",
      descriptionLabel: "Tavsif",
      descriptionPlaceholder: "Bu agent nima uchun kerak?",
      systemPromptLabel: "Tizim prompti",
      systemPromptPlaceholder:
        "Sen foydali yordamchisan. Mijozlar haqidagi savollarga javob berish uchun mavjud vositalardan foydalan.",
      systemPromptHint:
        "Har bir suhbat boshida yuboriladi va har bir ishga tushirishga qotiriladi, shunda oʻtgan ishga tushirishlar oʻz asl maʼnosini saqlaydi.",
      activeLabel: "Faol — nofaol agentlarni ishga tushirib boʻlmaydi",
      webToolsLabel: "Veb-vositalar — agentga internetda qidirish va sahifalarni oʻqishga ruxsat beradi",
      responseStyleLabel: "Javob shakli",
      responseStyleHint: "Agent javoblari qanchalik uzun va batafsil boʻlishi.",
      responseStyleConcise: "Qisqa",
      responseStyleExtended: "Kengaytirilgan",
      responseStyleDetailed: "Detallab tushuntirilgan",
    },
    model: {
      title: "Model",
      description: "Provayderlarni bu serverni ishga tushirgan kishi sozlaydi.",
      providerLabel: "Provayder",
      providerPlaceholder: "Provayderni tanlang",
      noApiKeySuffix: " (API kalit yoʻq)",
      modelLabel: "Model",
      modelPlaceholder: "Modelni tanlang",
      temperatureLabel: "Harorat",
      temperaturePlaceholder: "provayder boʻyicha standart",
      stepLimitLabel: "Qadam chegarasi",
      stepLimitHint: "Agent yakunlashdan oldin necha marta vositalardan foydalanishi mumkin.",
    },
    toolsSection: {
      title: "Vositalar",
      description: "Modelga faqat shu yerda yoqilgan narsalar taklif qilinadi.",
      emptyTitle: "Ulangan vosita serverlari yoʻq",
      emptyDescription: "Avval MCP serverini ulang — uning vositalari shu yerda paydo boʻladi.",
      goToServers: "Vosita serverlariga oʻtish",
      availableCount_one: "{count} ta vosita mavjud",
      availableCount_few: "{count} ta vosita mavjud",
      availableCount_many: "{count} ta vosita mavjud",
      availableCount_other: "{count} ta vosita mavjud",
      useAllLabel: "Barchasidan foydalanish",
      autoIncludeHint: "Bu serverga keyinroq qoʻshilgan vositalar avtomatik ravishda mavjud boʻladi.",
    },
    saveFirst: {
      title: "Plaginlar, Telegram va xotira",
      description:
        "Avval agentni saqlang — shundan keyin Plaginlar, Telegram va Xotira boʻlimlari paydo boʻladi.",
    },
    submit: {
      save: "Agentni saqlash",
      saving: "Saqlanmoqda…",
    },
    deleteButton: "Oʻchirish",
    deleteConfirm:
      "{name} oʻchirilsinmi? Uning xotirasi, Telegram boti va jadvallari oʻchiriladi. Oʻtgan ishga tushirishlar Ishga tushirishlar sahifasida qoladi.",
    title: {
      new: "Yangi agent",
      edit: "Agentni tahrirlash",
    },
    description: "Unga koʻrsatmalar bering, model tanlang va qaysi vositalardan foydalanishini belgilang.",
    back: "Orqaga",
    tabs: {
      settings: "Sozlamalar",
      plugins: "Plaginlar",
      telegram: "Telegram",
      memory: "Xotira",
    },
  },
  memory: {
    toasts: {
      loadFailed: "Xotirani yuklab boʻlmadi.",
      updateAgentFailed: "Agentni yangilab boʻlmadi.",
      saveFailed: "Yozuvni saqlab boʻlmadi.",
      editFailed: "Yozuvni yangilab boʻlmadi.",
      deleted: "Yozuv oʻchirildi.",
      deleteFailed: "Yozuvni oʻchirib boʻlmadi.",
    },
    deleteConfirm: "Bu yozuv butunlay oʻchirilsinmi?",
    loading: "Xotira yuklanmoqda…",
    title: "Xotira",
    savedCount_one: "{count} ta fakt saqlangan.",
    savedCount_few: "{count} ta fakt saqlangan.",
    savedCount_many: "{count} ta fakt saqlangan.",
    savedCount_other: "{count} ta fakt saqlangan.",
    hintEnabled:
      "Bu agent bilan boʻlgan barcha chatlarda, jumladan Telegramda, umumiy. Yangi faktlar har bir ishga tushirishga kiritiladi.",
    hintDisabled: "Xotira oʻchirilgan — agent ularni koʻrmaydi va saqlamaydi.",
    addPlaceholder: "Agent eslab qolishi kerak boʻlgan faktni qoʻshing…",
    saveButton: "Yozuvni saqlash",
    searchPlaceholder: "Xotirada qidirish…",
    emptyNone: "Hozircha yozuvlar yoʻq. Agent suhbat davomida faktlarni saqlaydi, yoki yuqorida birini qoʻshing.",
    emptyNoMatch: "“{query}” boʻyicha hech narsa topilmadi.",
    editSaveButton: "Saqlash",
    editCancelButton: "Bekor qilish",
    editAria: "Yozuvni tahrirlash",
    deleteAria: "Yozuvni oʻchirish",
  },
  pluginsTab: {
    toasts: {
      loadFailed: "Plaginlarni yuklab boʻlmadi.",
      enabled: "{name} yoqildi.",
      enableFailed: "Bu plaginni yoqib boʻlmadi.",
      saved: "{name} saqlandi.",
      saveConfigFailed: "Bu plaginni saqlab boʻlmadi.",
      disabled: "{name} oʻchirildi.",
      disableFailed: "Bu plaginni oʻchirib boʻlmadi.",
      missingRequired: "Zarur: {fields}",
    },
    loading: "Plaginlar yuklanmoqda…",
    mailAccountSetupBadge: "Hisob sozlanishi kerak",
    notionSetupBadge: "Integratsiya tokeni kerak",
    telegramSetupBadge: "QR orqali kirish kerak",
    browseTitle: "Plaginlar",
    searchPlaceholder: "Plaginlarni qidirish…",
    emptyNone: "Plaginlar mavjud emas.",
    emptyNoMatch: "“{query}” boʻyicha hech narsa topilmadi.",
    needsApiKeyBadge: "API kalit kerak",
    needsGoogleBadge: "Google hisobi kerak",
    removedBadge: "Endi mavjud emas",
    backButton: "Barcha plaginlar",
    skillsTitle: "Koʻnikmalar",
    noSkills: "Bu plaginning koʻnikmalari yoʻq.",
    mcpServersTitle: "MCP serverlari",
    noExternalServers: "Bu plagin oʻz vositalarini platforma ichida bajaradi — tashqi serverlar yoʻq.",
    connectionErrorTitle: "Ulanish xatosi",
    configTitle: "Sozlash",
    secretFieldPlaceholder: "Joriy qiymatni saqlash uchun boʻsh qoldiring",
    saveConfigButton: "Sozlamalarni saqlash",
    disableConfirmOAuth:
      "Bu plagin agent uchun oʻchirilsinmi? Uning Google hisobi uzilib qoladi; saqlangan maʼlumotlar qoladi.",
    disableConfirmPlain: "Bu plagin agent uchun oʻchirilsinmi? Saqlangan maʼlumotlar qoladi.",
    oauth: {
      toasts: {
        connectFailed: "Ulanishni boshlab boʻlmadi.",
        disconnected: "Google hisobi uzildi.",
      },
      unavailableHint:
        "Google ulanishlarini yoqish uchun server administratori GOOGLE_CLIENT_ID, GOOGLE_CLIENT_SECRET va GOOGLE_OAUTH_REDIRECT_URI ni belgilashi kerak.",
      title: "Google hisobi",
      connectButton: "{name}ni ulash",
      reconnectBadge: "Qayta ulanish kerak",
      lostTitle: "Google kirish huquqi yoʻqoldi",
      reconnectButton: "Qayta ulash",
      disconnectConfirm: "{who} bu agentdan uzilsinmi?",
      accountFallback: "bu Google hisobi",
      connectPrompt: "Bu agent foydalanishi kerak boʻlgan kalendarga ega Google hisobini ulang.",
    },
  },
  telegram: {
    toasts: {
      loadFailed: "Telegram sozlamalarini yuklab boʻlmadi.",
      missingToken: "Avval @BotFather dan bot tokenini joylashtiring.",
      connected: "@{username} sifatida ulandi.",
      saveFailed: "Saqlab boʻlmadi.",
      disconnected: "Bot uzildi.",
    },
    invalidIds: "Bular user ID emas: {ids}",
    disconnectConfirm: "Bu Telegram boti uzilsinmi? Ruxsat roʻyxati ham oʻchiriladi.",
    title: "Telegram",
    description:
      "Bu agent bilan Telegramdan gaplashing — toʻgʻridan-toʻgʻri yoki guruhda (botni tilga oling yoki /ask dan foydalaning). Faqat ruxsat roʻyxatidagi Telegram foydalanuvchilariga javob beriladi, qayerdan yozishlaridan qatʼi nazar.",
    tokenSuffix: "(token ••••{last4})",
    steps: {
      step1: "Telegramda @BotFather ga yozing, /newbot yuboring va tokenni nusxalang.",
      step2: "Tokenni quyiga joylashtiring va saqlang.",
      step3: "Botingizga /start yuboring — u ruxsat roʻyxati uchun user IDingiz bilan javob beradi.",
      step4:
        "Guruhlar uchun: @BotFather da /setprivacy → Disable buyrugʻini bajaring, soʻng botni guruhga qoʻshing (agar u allaqachon u yerda boʻlsa, qayta qoʻshing) — aks holda Telegram faqat /buyruqlarni yetkazadi, @tilga olishlarni emas.",
    },
    errorTitle: "Bot xatosi",
    tokenLabel: "Bot tokeni",
    tokenPlaceholderKeep: "Joriy tokenni saqlash uchun boʻsh qoldiring",
    userIdsLabel: "Ruxsat berilgan user IDlar",
    userIdsHint:
      "Har birini alohida qatorga yozing. Roʻyxatdagi foydalanuvchi botga istalgan joydan — shaxsiy chatdan yoki istalgan guruhdan — yoza oladi. Roʻyxatda yoʻq kishi oʻz user IDsi bilan javob oladi, shuni shu yerga joylashtirishingiz mumkin.",
    submit: {
      save: "Telegram sozlamalarini saqlash",
      connect: "Botni ulash",
    },
  },
  connections: {
    title: "Vosita serverlari",
    description: "MCP serverini ulang — uning vositalari agentlaringiz uchun mavjud boʻladi.",
    addServer: "Server qoʻshish",
    empty: {
      title: "Hozircha vosita serverlari yoʻq",
      description:
        "Agentlar faqat siz ulagan vositalardan foydalana oladi. MCP server URL manzilini qoʻshing — uning vositalari avtomatik aniqlanadi.",
      action: "Birinchi serveringizni qoʻshing",
    },
    toasts: {
      loadFailed: "Vosita serverlarini yuklab boʻlmadi.",
      reachable: "{name} ishlayapti.",
      catalogUpdated: "Katalog yangilandi: {added} ta qoʻshildi, {updated} ta yangilandi, {removed} ta oʻchirildi.",
      loadToolsFailed: "Vositalar roʻyxatini yuklab boʻlmadi.",
      removed: "{name} oʻchirildi.",
      connectFailed: "Bu serverga ulanib boʻlmadi.",
    },
    connectedCount_one: "Ulandi. {count} ta vosita topildi.",
    connectedCount_few: "Ulandi. {count} ta vosita topildi.",
    connectedCount_many: "Ulandi. {count} ta vosita topildi.",
    connectedCount_other: "Ulandi. {count} ta vosita topildi.",
    lastAttemptFailedTitle: "Oxirgi urinish muvaffaqiyatsiz tugadi",
    serverInfo: "Server: {name}{version}",
    checkedAt: "Tekshirildi: {when}",
    test: "Sinov",
    refreshTools: "Vositalarni yangilash",
    browseTools: "Vositalarni koʻrish",
    removeConfirm: "{name} oʻchirilsinmi? Undan foydalanadigan agentlar bu vositalarni yoʻqotadi.",
    remove: "Oʻchirish",
    noTools: "Bu server hech qanday vosita taqdim etmaydi.",
    unsupported: "Qoʻllab-quvvatlanmaydi",
    callsAs: "{name} nomi bilan chaqiriladi",
    dialog: {
      title: "Vosita serverini qoʻshish",
      description:
        "Masofaviy MCP serverining URL manzilini joylashtiring. Biz darhol ulanamiz va u taklif qiladigan vositalar roʻyxatini koʻrsatamiz.",
      namePlaceholder: "Namuna vositalar",
      urlLabel: "Server URL manzili",
      urlHint: "Streamable HTTP yoki SSE — server qaysi birini ishlatishini avtomatik aniqlaymiz.",
      authLabel: "Autentifikatsiya",
      authNone: "Yoʻq",
      authBearer: "Bearer token",
      authHeader: "Maxsus sarlavha",
      authBasic: "Basic (user:password)",
      headerNameLabel: "Sarlavha nomi",
      secretLabel: "Maxfiy kalit",
      secretLabelBasic: "username:password",
      secretHint: "Saqlashdan oldin shifrlanadi va boshqa hech qachon koʻrsatilmaydi.",
      connect: "Ulash",
      connecting: "Ulanmoqda…",
    },
  },
  mailAccounts: {
    title: "Email hisoblar",
    description:
      "Bu agentga kerak boʻlgan miqdorda pochta qutilarini qoʻshing. Har biri ilova paroli ishlatadi, hech qachon asosiy parolingiz emas.",
    addAccount: "Hisob qoʻshish",
    loading: "Hisoblar yuklanmoqda…",
    empty: "Hozircha hisoblar yoʻq. Siz birortasini qoʻshmaguningizcha, agentning pochta vositalari uni soʻrayveradi.",
    access: {
      read: { label: "Oʻqish", hint: "Qidirish va oʻqish; oʻqilgan deb belgilash yoki bayroqcha qoʻyish mumkin." },
      send: { label: "Oʻqish + yuborish", hint: "Shuningdek, xat yozish va javob berish mumkin." },
      full: { label: "Toʻliq", hint: "Shuningdek, koʻchirish va Savatchaga oʻchirish mumkin." },
    },
    status: {
      error: "Xatolik",
    },
    testAria: "{email} ni sinash",
    editAria: "{email} ni tahrirlash",
    removeAria: "{email} ni oʻchirish",
    toasts: {
      loadFailed: "Pochta hisoblarini yuklab boʻlmadi.",
      connected: "{email} ulandi.",
      connectFailed: "{email} ni ulab boʻlmadi.",
      testFailed: "Bu hisobni sinab boʻlmadi.",
      removeFailed: "Bu hisobni oʻchirib boʻlmadi.",
      saveFailed: "Bu hisobni saqlab boʻlmadi.",
    },
    removeConfirm: "{email} bu agentdan oʻchirilsinmi? Saqlangan parol oʻchiriladi.",
    dialog: {
      needPassword: "Ilova parolini kiriting.",
      needServers: "Provayderni tanlang yoki «Qoʻshimcha» boʻlimida serverlarni toʻldiring.",
      editTitle: "{email} ni tahrirlash",
      addTitle: "Email hisob qoʻshish",
      description: "Provayderingizning ilova parolidan foydalaning. Saqlash paytida ulanish tekshiriladi.",
      providerLabel: "Provayder",
      providerOther: "Boshqa (serverlarni kiriting)",
      emailLabel: "Email manzil",
      passwordLabel: "Ilova paroli",
      passwordPlaceholderPlain: "Joriysini saqlash uchun boʻsh qoldiring",
      passwordPlaceholderLast4: "Joriysini saqlash uchun boʻsh qoldiring (••••{last4})",
      helpLink: "{provider} uchun ilova parolini qanday yaratish mumkin",
      displayNameLabel: "Koʻrsatiladigan nom",
      labelLabel: "Yorliq",
      labelPlaceholder: "Manzildan, masalan gmail",
      accessLabel: "Agent nima qila oladi",
      advanced: "Qoʻshimcha",
      imapTitle: "Kiruvchi (IMAP)",
      smtpTitle: "Chiquvchi (SMTP)",
      hostAria: "{title}: host",
      portAria: "{title}: port",
      securityAria: "{title}: xavfsizlik",
      usernameAria: "{title}: foydalanuvchi nomi",
      securitySsl: "SSL/TLS",
      securityStarttls: "STARTTLS",
      usernamePlaceholder: "Foydalanuvchi nomi (standart holatda email manzil)",
      sentFolderLabel: "Yuborilganlar papkasi",
      sentFolderPlaceholder: "Avtomatik aniqlanadi",
      appendSentLabel: "Yuborilgan xat nusxasini Yuborilganlar papkasiga saqlash",
      save: "Saqlash",
    },
  },
  notionPanel: {
    title: "Notion ish maydoni",
    description:
      "Ichki integratsiya tokenini joylashtiring. Agent faqat Notion ichida integratsiyaga ulashilgan sahifalarni ko'radi.",
    loading: "Ulanish tekshirilmoqda…",
    tokenLabel: "Integratsiya tokeni",
    connectButton: "Ulash",
    cancelButton: "Bekor qilish",
    replaceButton: "Tokenni almashtirish",
    unknownWorkspace: "Notion ish maydoni",
    tokenHint: "Token ••••{last4}",
    status: {
      ok: "Ulangan",
      error: "Xato",
    },
    testAria: "Ulanishni tekshirish",
    removeAria: "Notionni uzish",
    help: "Integratsiya yarating, kerakli sahifalarni unga ulashing va tokenini joylashtiring:",
    removeConfirm: "Notion shu agentdan uzilsinmi? Saqlangan token o'chiriladi.",
    toasts: {
      loadFailed: "Notion ulanishini yuklab bo'lmadi.",
      connected: "{workspace} ulandi.",
      connectFailed: "Notionni ulab bo'lmadi.",
      testOk: "Ulanish ishlayapti.",
      testFailed: "Ulanishni tekshirib bo'lmadi.",
      removeFailed: "Notionni uzib bo'lmadi.",
    },
  },
  telegramPanel: {
    title: "Telegram hisobi",
    description:
      "QR-kodni skanerlab, oʻz Telegram hisobingizni ulang. Agent xabarlarni bot emas, siz nomingizdan oʻqiydi va yuboradi.",
    loading: "Ulanish tekshirilmoqda…",
    unavailableTitle: "Telegram mavjud emas",
    unavailableHint:
      "Bu serverda Telegram ilova maʼlumotlari sozlanmagan. Administrator TELEGRAM_PLUGIN_API_ID va TELEGRAM_PLUGIN_API_HASH ni oʻrnatishi kerak.",
    connectButton: "Telegramni ulash",
    reconnectButton: "Qayta ulash",
    cancelButton: "Bekor qilish",
    unknownAccount: "Telegram hisobi",
    qrStep1: "Telefoningizda Telegramni oching.",
    qrStep2: "Sozlamalar → Qurilmalar → Kompyuterni ulash boʻlimiga oʻting.",
    qrStep3: "Telefoningizni shu kodga qarating.",
    qrAlt: "Telegramga kirish QR-kodi",
    passwordLabel: "Ikki bosqichli tekshiruv paroli",
    passwordHint: "Hisobingizda 2FA paroli yoqilgan. Kirishni yakunlash uchun uni kiriting.",
    submitPasswordButton: "Yuborish",
    status: {
      ok: "Ulangan",
      error: "Xato",
    },
    testAria: "Ulanishni tekshirish",
    disconnectAria: "Telegramni uzish",
    disconnectConfirm: "Telegramni bu agentdan uzasizmi? Saqlangan sessiya oʻchiriladi.",
    toasts: {
      loadFailed: "Telegram ulanishini yuklab boʻlmadi.",
      startFailed: "Telegramga kirishni boshlab boʻlmadi.",
      loginFailed: "Telegramga kirish amalga oshmadi.",
      connected: "Telegram ulandi.",
      testOk: "Ulanish ishlayapti.",
      testFailed: "Ulanishni tekshirib boʻlmadi.",
      disconnectFailed: "Telegramni uzib boʻlmadi.",
    },
  },
  plugins: {
    title: "Plaginlar",
    description: "Agentlaringiz foydalanishi mumkin boʻlgan koʻnikmalar va ulangan serverlar toʻplamlari.",
    toasts: {
      loadFailed: "Plaginlarni yuklab boʻlmadi.",
    },
    empty: {
      title: "Plaginlar mavjud emas",
      description: "Plaginlar serverga oʻrnatiladi. Ushbu joylashtirishni boshqaradigan kishidan birini qoʻshishni soʻrang.",
    },
    enableHint: "Plaginlarni har bir agent uchun agent muharririda yoqing.",
    removedBadge: "Olib tashlangan",
    needsApiKeyBadge: "API kalit kerak",
    needsGoogleBadge: "Google hisobi kerak",
    noSkills: "Bu plaginning koʻnikmalari yoʻq.",
  },
  schedules: {
    title: "Jadvallar",
    description: "Agentni jadval boʻyicha yoki belgilangan vaqtda bir marta, hech kim kuzatmasdan ishga tushiring.",
    newSchedule: "Yangi jadval",
    empty: {
      title: "Hozircha jadvallar yoʻq",
      noAgents: "Avval agent yarating, keyin unga jadval belgilashingiz mumkin.",
      description: "Agentga cron ifodasi yoki sana va promptni bering — u oʻzi ishlaydi.",
      action: "Jadval yaratish",
    },
    toasts: {
      loadFailed: "Jadvallarni yuklab boʻlmadi.",
      runFinished: "Ishga tushirish {status} holati bilan yakunlandi.",
      deleted: "Jadval oʻchirildi.",
      created: "Jadval yaratildi.",
      createFailed: "Jadvalni yaratib boʻlmadi.",
    },
    missedRunsTitle: "Oʻtkazib yuborilgan ishga tushirishlar qayta bajarilmaydi",
    missedRunsDescription:
      "Agar worker ishlamay qolgan boʻlsa, eng oxirgi oʻtkazib yuborilgan slot u qayta ishga tushganda bir marta bajariladi, qolganlari esa oʻtkazib yuboriladi. Jadval bir slotda koʻpi bilan bir marta ishlaydi, shuning uchun xat yuboradigan agent toʻplangan nusxalarni yubormaydi. Shu davrda muddati kelgan bir martalik vazifalar baribir, kechikib boʻlsa-da, ishga tushadi.",
    status: {
      completed: "Yakunlandi",
      fired: "Ishga tushdi",
      failed: "Xatolik",
      pending: "Kutilmoqda",
      active: "Faol",
      paused: "Toʻxtatilgan",
      pausedReason: "Toʻxtatilgan · {reason}",
    },
    onceBadge: "Bir marta · {when}",
    nextRunSuffix: " · keyingi ishga tushirish {when}",
    setInChat: "Chatda belgilangan",
    lastRun: "Oxirgi ishga tushirish {when}",
    outcome: "Natija: {status}",
    consecutiveFailures_one: "{count} ta ketma-ket muvaffaqiyatsizlik",
    consecutiveFailures_few: "{count} ta ketma-ket muvaffaqiyatsizlik",
    consecutiveFailures_many: "{count} ta ketma-ket muvaffaqiyatsizlik",
    consecutiveFailures_other: "{count} ta ketma-ket muvaffaqiyatsizlik",
    runNow: "Hozir ishga tushirish",
    deleteConfirm: '"{name}" jadvalini oʻchirish kerakmi?',
    delete: "Oʻchirish",
    presets: {
      every15: "Har 15 daqiqada",
      hourly: "Har soatda",
      weekdayNine: "Har ish kuni soat 9:00 da",
      dailyMidnight: "Har kuni yarim tunda",
      mondaysEight: "Har dushanba soat 8:00 da",
    },
    dialog: {
      description: "Agent quyidagi prompt bilan hech kim kuzatmasdan ishlaydi.",
      agentLabel: "Agent",
      agentPlaceholder: "Agentni tanlang",
      namePlaceholderCron: "Ish kunlari xulosasi",
      namePlaceholderOnce: "Aliga qarzni qaytarish",
      whenLabel: "Qachon",
      recurring: "Takrorlanuvchi",
      once: "Bir marta",
      cronAria: "Cron ifodasi",
      dateTimeAria: "Sana va vaqt",
      timezoneAria: "Vaqt zonasi",
      invalidExpression: "Ifoda notoʻgʻri.",
      nextRunsLabel: "Keyingi ishga tushirishlar",
      promptLabel: "Prompt",
      promptPlaceholderCron: "5 tadan ortiq ochiq tiketi bor mijozlarni tekshir va ular boʻyicha xulosa tuz.",
      promptPlaceholderOnce: "Menga Ali 500 000 soʻm qarzdorligini, muddati bugun ekanini eslat.",
      create: "Jadval yaratish",
    },
  },
  runs: {
    title: "Ishga tushirishlar",
    description: {
      admin:
        "Platformadagi barcha agent ishga tushirishlari, chaqirilgan vositalarning toʻliq yozuvi bilan.",
      user: "Sizning agent ishga tushirishlaringiz. Toʻliq tafsilotlar adminlarga ochiq.",
    },
    filters: {
      allAgents: "Barcha agentlar",
      allStatuses: "Barcha holatlar",
      allTriggers: "Barcha manbalar",
      allTelegramChats: "Barcha Telegram chatlari",
    },
    trigger: {
      chat: "Chat",
      schedule: "Jadval",
      telegram: "Telegram",
    },
    empty: {
      title: "Hozircha ishga tushirishlar yoʻq",
      description: "Agent bilan suhbatlashing yoki jadval ishga tushishini kuting — tarix shu yerda paydo boʻladi.",
    },
    columns: {
      status: "Holat",
      trigger: "Manba",
      telegramChat: "Telegram chati",
      steps: "Qadamlar",
      toolCalls: "Vosita chaqiruvlari",
      tokens: "Tokenlar",
      cost: "Narxi",
      duration: "Davomiyligi",
      started: "Boshlangan",
      created: "Yaratilgan",
    },
    tokensTooltip: "kirish / chiqish tokenlari",
    viewTrace: "Trassa",
    toasts: {
      loadFailed: "Ishga tushirishlarni yuklab boʻlmadi.",
    },
    detail: {
      title: "Ishga tushirish trassasi",
      description: "Agent aynan nima qilgani, sodir boʻlgani kabi yozib olingan.",
      back: "Ishga tushirishlarga qaytish",
      toasts: {
        loadFailed: "Bu trassani yuklab boʻlmadi.",
      },
      runFailed: "Ishga tushirish muvaffaqiyatsiz tugadi",
      snapshotTitle: "Ishga tushirish vaqtidagi agent sozlamalari",
      snapshotHint:
        "Ishga tushirish boshlanganda saqlab qolingan, shuning uchun agentga keyin kiritilgan oʻzgarishlar tarixni oʻzgartirmaydi.",
      llmCallsTitle: "LLM chaqiruvlari ({count})",
      noLlmCalls:
        "Soʻrovlar yozilmagan. Soʻrovlarni yozib olish paydo boʻlishidan oldingi ishga tushirishlarda hech narsa koʻrsatilmaydi.",
      memoryExtraction: "Xotirani ajratib olish",
      stepIndex: "{n}-qadam",
      summary: "xulosa",
      messageCount_one: "{count} ta xabar",
      messageCount_few: "{count} ta xabar",
      messageCount_many: "{count} ta xabar",
      messageCount_other: "{count} ta xabar",
      requestLabel: "Soʻrov — providerga aynan qanday yuborilgan boʻlsa",
      responseLabel: "Javob — provider qaytargan holicha",
      toolCallsTitle: "Vosita chaqiruvlari ({count})",
      noToolCalls: "Bu ishga tushirish hech qanday vositadan foydalanmadi.",
      truncated: "qisqartirilgan",
      argumentsLabel: "Argumentlar",
      redacted: "(ulanish siyosati tomonidan yashirilgan)",
      resultLabel: "Natija",
      noResult: "(natija yozilmagan)",
      stepsCount_one: "{count} ta qadam",
      stepsCount_few: "{count} ta qadam",
      stepsCount_many: "{count} ta qadam",
      stepsCount_other: "{count} ta qadam",
      tokensIn: "{count} kirish",
      tokensOut: "{count} chiqish",
      tokensCached: "{count} keshdan",
      tokensTotal: "{count} jami",
    },
  },
  activity: {
    title: "Faollik",
    description: "Hisobingizdagi soʻnggi harakatlar.",
    toasts: {
      loadFailed: "Faollikni yuklab boʻlmadi.",
    },
    empty: "Hozircha faollik qayd etilmagan.",
    columns: {
      time: "Vaqt",
      action: "Harakat",
      target: "Obyekt",
      ip: "IP",
    },
    changes: {
      redacted: "oʻzgartirildi",
    },
  },
  billing: {
    title: "Billing",
    workspaceLabel: "{name} uchun billing",
    loadFailed: "Billingni yuklab boʻlmadi",
    yourPlan: "Tarifingiz: {plan}",
    renewsOn: "Yangilanish / bekor qilinish sanasi: {date}",
    balanceTitle: "Balans",
    balanceHint: "Ishga tushirishlar va ovozni matnga o‘girish shu balansdan yechiladi.",
    topUpCta: "Balansingiz tugadi. Agentlardan foydalanishni davom ettirish uchun hisobingizni to‘ldiring.",
    tokens: "Tokenlar",
    agentsUsage: "Agentlar: {used} / {max}",
    free: "Bepul",
    tokenCapPeriod_one: "{formatted} ta token / 30 kun",
    tokenCapPeriod_few: "{formatted} ta token / 30 kun",
    tokenCapPeriod_many: "{formatted} ta token / 30 kun",
    tokenCapPeriod_other: "{formatted} ta token / 30 kun",
    planAgents_one: "{count} ta agent",
    planAgents_few: "{count} ta agent",
    planAgents_many: "{count} ta agent",
    planAgents_other: "{count} ta agent",
    upgradeTitle: "Tarifni qanday oshirish mumkin",
    upgradeBefore: "Quyidagi kartaga toʻlov qiling:",
    upgradeMiddle: ", soʻngra bogʻlaning:",
    upgradeAfter: "— tarifni faollashtirish uchun.",
  },
  resetPassword: {
    title: "Parolni tiklash",
    description: {
      email: "Email manzilingizni kiriting — kod yuboramiz.",
      reset: "Kodni va yangi parolni kiriting.",
    },
    emailLabel: "Email",
    emailPlaceholder: "siz@example.com",
    codeLabel: "Tiklash kodi",
    codePlaceholder: "6 xonali kod",
    newPasswordLabel: "Yangi parol",
    newPasswordPlaceholder: "Kamida 8 ta belgi",
    submit: {
      wait: "Kuting…",
      sendCode: "Kod yuborish",
      updatePassword: "Parolni yangilash",
    },
    backToSignIn: "Kirishga qaytish",
    toasts: {
      codeSent: "Agar bunday hisob mavjud boʻlsa, tiklash kodi allaqachon yuborildi.",
      passwordUpdated: "Parol yangilandi.",
      genericError: "Nimadir xato ketdi. Qaytadan urinib koʻring.",
    },
  },
  oauthCallback: {
    toasts: {
      startAgain: "Ulanishni agent muharririda qaytadan boshlang.",
      cancelled: "Google ulanishi bekor qilindi.",
      incomplete: "Google ulanishni yakunlamadi.",
      connected: "{email} sifatida ulandi.",
      connectFailed: "Google ulanishini oʻrnatib boʻlmadi.",
    },
    yourGoogleAccountFallback: "Google hisobingiz",
    connecting: "Google bilan bogʻlanmoqda…",
  },
  workspaceSettings: {
    title: "Ish maydoni sozlamalari",
    description: "Aʼzolarni, takliflarni va ushbu ish maydonini boshqaring.",
    yourRole: "Sizning rolingiz",
    leave: "Tark etish",
    leaveConfirm: "«{name}»ni tark etasizmi? Sizni qayta taklif qilishmasa, kirish huquqini yoʻqotasiz.",
    removeConfirm: "{email}ni ushbu ish maydonidan olib tashlaysizmi?",
    deleteConfirm: "«{name}»ni oʻchirasizmi? Bu barcha maʼlumotlarni butunlay oʻchiradi. Buni qaytarib boʻlmaydi.",
    lastOwnerHint: "Ish maydonida kamida bitta egasi qolishi kerak.",
    roles: {
      owner: "Egasi",
      admin: "Admin",
      member: "Aʼzo",
    },
    general: {
      title: "Umumiy",
      description: "Ushbu ish maydoni haqida asosiy maʼlumot.",
      save: "Saqlash",
    },
    members: {
      title: "Aʼzolar",
      description: "Ushbu ish maydoniga kirish huquqiga ega barcha odamlar.",
      columnMember: "Aʼzo",
      columnRole: "Rol",
      remove: "Olib tashlash",
    },
    invite: {
      title: "Kimnidir taklif qilish",
      description: "Ish maydoniga qoʻshilish uchun email orqali taklif yuboring.",
      emailLabel: "Email",
      roleLabel: "Rol",
      send: "Taklif yuborish",
      empty: "Kutilayotgan takliflar yoʻq.",
      expires: "Muddati {when}",
      revoke: "Bekor qilish",
      linkHint: "Yoki taklif havolasini nusxalang (pochta sozlanmagan boʻlsa ham ishlaydi):",
      copy: "Havolani nusxalash",
      copied: "Nusxalandi",
      resend: "Qayta yuborish",
    },
    danger: {
      title: "Xavfli zona",
      description: "Ish maydonini oʻchirish qaytarib boʻlmaydi.",
      delete: "Ish maydonini oʻchirish",
    },
    toasts: {
      loadFailed: "Ish maydonini yuklab boʻlmadi.",
      membersLoadFailed: "Aʼzolarni yuklab boʻlmadi.",
      invitesLoadFailed: "Takliflarni yuklab boʻlmadi.",
      renamed: "Ish maydoni nomi oʻzgartirildi.",
      roleUpdated: "{email} roli yangilandi.",
      left: "Siz ish maydonini tark etdingiz.",
      removed: "{email} olib tashlandi.",
      inviteSent: "{email} taklif qilindi.",
      inviteResent: "{email} uchun yangi taklif havolasi yaratildi.",
      inviteFailed: "Taklifni yuborib boʻlmadi.",
      inviteRevoked: "Taklif bekor qilindi.",
      deleted: "Ish maydoni oʻchirildi.",
    },
  },
  admin: {
    grant: {
      workspacesTitle: "Ish maydonlari",
      workspacesDescription: "Ushbu foydalanuvchining ish maydonlaridan biriga tarif bering.",
      columnWorkspace: "Ish maydoni",
      columnRole: "Rol",
      columnPlan: "Tarif",
      columnRenews: "Yangilanadi",
      button: "Berish",
      none: "Bu foydalanuvchi hech qanday ish maydoniga aʼzo emas.",
      loadFailed: "Foydalanuvchining ish maydonlarini yuklab boʻlmadi.",
      granted: "{workspace} ish maydoniga {plan} tarifi {days} kunga berildi.",
      grantFailed: "Tarifni berib boʻlmadi.",
      daysInvalid: "Kunlar soni 1 dan 3650 gacha boʻlishi kerak.",
      columnBalance: "Balans",
      topUpButton: "Toʻldirish",
      toppedUp: "{workspace} ish maydoniga {amount} qoʻshildi.",
      topUpFailed: "Balansni toʻldirib boʻlmadi.",
      amountInvalid: "Miqdor $0.01 dan $10 000 gacha boʻlishi kerak.",
    },
  },
}
